import { formatDateParam, makeRequest } from "../lib/makeRequest";

export const package_overall = (data) =>
  makeRequest("/package-summaries/overall", {
    coveredDate: formatDateParam(data.dates.from),
  });

export const package_cluster = (data) =>
  makeRequest(`/package-summaries/cluster/${data.clusterId}`, {
    coveredDate: formatDateParam(data.dates.from),
  });

export const package_area = (data) =>
  makeRequest(`/package-summaries/area/${data.areaId}`, {
    coveredDate: formatDateParam(data.dates.from),
  });

export const package_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("coveredDate", data.dates.from);
  return makeRequest(
    `/package-summaries/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};

export const package_daily_overall = (data) =>
  makeRequest("/daily-packages/overall", {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const package_daily_cluster = (data) =>
  makeRequest(`/daily-packages/cluster/${data.clusterId}`, {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const package_daily_area = (data) =>
  makeRequest(`/daily-packages/area/${data.areaId}`, {
    from: formatDateParam(data.dates.from),
    to: formatDateParam(data.dates.to),
  });

export const package_daily_branch = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", data.dates.from);
  urlParams.append("to", data.dates.to);
  return makeRequest(
    `/daily-packages/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
